import { IRuleUselessMessageItem, IRuleUselessWarningItem } from '../rule.interface';

export const isRuleUselessMessageItem = (item: IRuleUselessWarningItem): item is IRuleUselessMessageItem =>
  'message' in item;
